import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/notificationActions';

const notificationActions = {

    create(notification) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .post(env.tashi + '/notifications/')
                .send(notification)
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createNotification({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.createNotification({ status: "success", data: notification }));
                    } else {
                        dispatch(actions.createNotification({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    delete(notificationID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .post(env.tashi + '/notifications/' + notificationID + "/delete")
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err && !err.ok) {
                        dispatch(actions.deleteNotification({ status: "failure", data: err }));
                        return;
                    }

                    dispatch(actions.deleteNotification({ status: "success", data: notificationID }));
                });
        };
    },

    deleteAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .post(env.tashi + "/notifications/deleteAll")
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err && !err.ok) {
                        dispatch(actions.deleteAllNotifications({ status: "failure", data: err }));
                        return;
                    }

                    dispatch(actions.deleteAllNotifications({ status: "success" }));
                });
        };
    },

    loadPage(pageSize) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .get(env.tashi + '/notifications/search/findAllPageable?page=0&size=' + pageSize + '&sort=timestamp,desc')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadPageNotification({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.notifications;

                    if (data) {
                        dispatch(actions.loadPageNotification({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadPageNotification({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadUnreadPageCount() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .get(env.tashi + '/notifications/search/countAllUnread')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadUnreadPageCountNotification({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadUnreadPageCountNotification({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadUnreadPageCountNotification({ status: "success", data: 0 }));
                    }
                });
        };
    },

    markAllAsRead() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .post(env.tashi + '/notifications/markAllRead')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err && !err.ok) {
                        dispatch(actions.markAllNotificationsAsRead({ status: "failure", data: err }));
                        return;
                    }

                    dispatch(actions.markAllNotificationsAsRead({ status: "success" }));
                });
        };
    },

    markAsRead(notificationID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .post(env.tashi + '/notifications/' + notificationID + "/markRead")
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err && !err.ok) {
                        dispatch(actions.markAsReadNotification({ status: "failure", data: err }));
                        return;
                    }

                    dispatch(actions.markAsReadNotification({ status: "success", data: notificationID }));
                });
        };
    },

    markAsUnread(notificationID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .post(env.tashi + '/notifications/' + notificationID + "/markUnread")
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err && !err.ok) {
                        dispatch(actions.markAsUnreadNotification({ status: "failure", data: err }));
                        return;
                    }

                    dispatch(actions.markAsUnreadNotification({ status: "success", data: notificationID }));
                });
        };
    },

    undelete(notificationID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForNotificationState());

            request
                .post(env.tashi + '/notifications/' + notificationID + "/restore")
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err && !err.ok) {
                        dispatch(actions.undeleteNotification({ status: "failure", data: err }));
                        return;
                    }

                    dispatch(actions.undeleteNotification({ status: "success", data: notificationID }));
                });
        };
    }

};

export default notificationActions;


/** WEBPACK FOOTER **
 ** ./src/app/actions/notificationActionCreators.js
 **/